import React from "react";
import GoogleMap, { type GoogleMapsProps } from "./GoogleMap/googlemap";
import SupportQuestionMark from "../supportbeacon/SupportQuestionMark";

interface Props extends GoogleMapsProps {
  height: number
  geoCode: server.dto.GeoCode
}

const GoogleMapOrError = (props: Props) => {
  const { height, geoCode, ...rest } = props;

  if (geoCode.hasError) {
    return <div className="flex align-center justify-center s1_gray panel-bg-color" style={{ height, minHeight: height }}>
      <div style={{ textAlign: "center" }}>
        <h1>{geoCode.userMessage}</h1>
        <div className="margin-top">
          <SupportQuestionMark articleId={geoCode.questionMark} />
        </div>
      </div>
    </div>;
  }

  return (
    <div style={{ height, minHeight: height }}>
      <GoogleMap {...rest} />
    </div>
  );
};

export default GoogleMapOrError;